import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Get the config for the account and external apps allowed for the account
export const getExternalAppsConfigThunk = createAsyncThunk(
	'accountExternalAppsConfig/getExternalAppsConfigThunk',
	async (params: { AccountID: string }) => {
		console.log('getExternalAppsConfigThunk params', params);
		const { AccountID } = params;
		const response = await api.get(
		    `/account/${AccountID.toLowerCase()}/external_apps_config`, //params,
		    { timeout: 30000 }
		);
		console.log('getExternalAppsConfigThunk response', response);
		return response.data;
	}
);

// Flag for Account and External Apps in General
export const enableExternalAppsThunk = createAsyncThunk(
	'enableExternalAppsThunk/enableExternalAppsThunk',
	async (params: { AccountID: string; Enabled: boolean }) => {
		console.log('enableExternalAppsThunk params ', params);
		const dataParams = {
            appsEnabled: params.Enabled,
		};
		const response = await api.put(
		    `/account/${params.AccountID.toLowerCase()}/enable_external_apps`,
		    dataParams,
		    { timeout: 30000 }
		);
		console.log('enableExternalAppsThunk response', response);
		return response.data;
	}
);

// Get all the External Apps from TCareExternalApps
export const getExternalAppsListThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/getExternalAppsListThunk',
	async () => {
		console.log('getExternalAppsListThunk');
		const response = await api.get(
		    `/external_apps/list`, //params,
		    { timeout: 30000 }
		);
		console.log('getExternalAppsListThunk response', response);
		return response.data;
	}
);
export const addExternalAppThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/addExternalAppThunk',
	async (params: { name: string; androidIdentifier: string; iconUrl:string }) => {
		console.log('addExternalAppThunk params ', params);
		const response = await api.post(
		    `/external_apps/new`,
		    params,
		    { timeout: 30000 }
		);
		console.log('addExternalAppThunk response', response);
		return response.data;
	}
);
// Get the info of the TCareExternalApp
export const getAppInfoThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/getAppInfoThunk',
	async (appId: string) => {
		console.log('getAppInfoThunk appId', appId);
		const response = await api.get(
		    `/external_app/${appId.toLowerCase()}/info`,
		    { timeout: 30000 }
		);
		console.log('getAppInfoThunk response', response);
		return response.data;
	}
);

export const deleteExternalAppThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/deleteExternalAppThunk',
	async (appId: string) => {
		console.log('deleteExternalAppThunk appId', appId);
		const response = await api.delete(
		    `/external_app/${appId.toLowerCase()}`,
		    { timeout: 30000 }
		);
		console.log('deleteExternalAppThunk response', response);
		return response.data;
	}
);

export const getAccountAppsAvailabilityThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/getAccountAppsAvailabilityThunk',
	async (accountId: string) => {
		console.log('getAccountAppsAvailabilityThunk accountId', accountId);
		const response = await api.get(
		    `/account/${accountId.toLowerCase()}/external_apps_availability`,
		    { timeout: 30000 }
		);
		console.log('getAccountAppsAvailabilityThunk response', response);
		return response.data;
	}
);
export const updateAccountAppAvailabilityThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/updateAccountAppAvailabilityThunk',
	async (params: { accountId: string; externalAppId: string; appEnabled: boolean; overwriteConfig:boolean }) => {
		const dataParams = {
            externalAppId: params.externalAppId,
            appEnabled: params.appEnabled,
            overwriteConfig: params.overwriteConfig
		};
		console.log('updateAccountAppAvailabilityThunk params ', dataParams);
		const response = await api.put(
		    `/account/${params.accountId.toLowerCase()}/update_app_account_availability`,
		    dataParams,
		    { timeout: 30000 }
		);
		console.log('updateAccountAppAvailabilityThunk response', response);
		return response.data;
	}
);

// Apply to All Apps
export const updateAccountAppsAvailabilityThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/updateAccountAppsAvailabilityThunk',
	async (params: { accountId: string; appsEnabled: boolean; }) => {
		const dataParams = {
            appsEnabled: params.appsEnabled
		};
		console.log('updateAccountAppsAvailabilityThunk params ', dataParams);
		const response = await api.put(
		    `/account/${params.accountId.toLowerCase()}/update_all_apps_account_availability`,
		    dataParams,
		    { timeout: 30000 }
		);
		console.log('updateAccountAppsAvailabilityThunk response', response);
		return response.data;
	}
);

export const getAccountAppsThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/getAccountAppsThunk',
	async (accountId: string) => {
		console.log('getAccountAppsThunk accountId', accountId);
		const response = await api.get(
		    `/account/${accountId.toLowerCase()}/external_apps_list`,
		    { timeout: 30000 }
		);
		console.log('getAccountAppsThunk response', response);
		return response.data;
	}
);

export const updateAccountAppsConfigThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/updateAccountAppsConfigThunk',
	async (params: { accountId: string; appsEnabled: boolean; overwriteConfig:boolean }) => {
		const dataParams = {
            appsEnabled: params.appsEnabled,
            overwriteConfig: params.overwriteConfig
		};
		console.log('updateAccountAppsConfigThunk params ', dataParams);
		const response = await api.put(
		    `/account/${params.accountId.toLowerCase()}/update_all_apps_account_config`,
		    dataParams,
		    { timeout: 30000 }
		);
		console.log('updateAccountAppsConfigThunk response', response);
		return response.data;
	}
);

export const resetAccountAppThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/resetAccountAppThunk',
	async (params: { accountId: string; externalAppId: string; appEnabled: boolean; overwriteConfig:boolean }) => {
		const dataParams = {
            externalAppId: params.externalAppId,
            appEnabled: params.appEnabled,
            overwriteConfig: params.overwriteConfig
		};
		console.log('resetAccountAppThunk params ', dataParams);
		const response = await api.put(
		    `/account/${params.accountId.toLowerCase()}/update_app_account_config`,
		    dataParams,
		    { timeout: 30000 }
		);
		console.log('resetAccountAppThunk response', response);
		return response.data;
	}
);

export const getPatientAppsThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/getPatientAppsThunk',
	async (patientId: string) => {
		console.log('getPatientAppsThunk patientId', patientId);
		const response = await api.get(
		    `/patient/${patientId.toLowerCase()}/external_apps_list`,
		    { timeout: 30000 }
		);
		console.log('getPatientAppsThunk response', response);
		return response.data;
	}
);

export const updatePatientAppsConfigThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/updatePatientAppsConfigThunk',
	async (params: { patientId: string; accountId: string; appsEnabled: boolean;}) => {
		const dataParams = {
      accountId: params.accountId,
      appsEnabled: params.appsEnabled
		};
		console.log('updatePatientAppsConfigThunk params ', dataParams);
		const response = await api.put(
		    `/patient/${params.patientId.toLowerCase()}/update_patient_all_apps_config`,
		    dataParams,
		    { timeout: 30000 }
		);
		console.log('updatePatientAppsConfigThunk response', response);
		return response.data;
	}
);

export const resetPatientAppThunk = createAsyncThunk(
	'accountExternalAppsConfigSlice/resetPatientAppThunk',
	async (params: { patientId: string; externalAppId: string; appEnabled: boolean;}) => {
		const dataParams = {
            externalAppId: params.externalAppId,
            appEnabled: params.appEnabled
		};
		console.log('resetPatientAppThunk params ', dataParams);
		const response = await api.put(
		    `/patient/${params.patientId.toLowerCase()}/update_patient_app_config`,
		    dataParams,
		    { timeout: 30000 }
		);
		console.log('resetPatientAppThunk response', response);
		return response.data;
	}
);



const initialState: {
	status: string;
	error: string;
	config: any;
  	app: any;
	appsConfig: any;
	accountApps : any;
	patientApps: any;
} = {
	status: '',
	error: '',
	config: {
		ExternalAppsEnabled: false,
		getPending : false,
		getComplete: false,
		updatePending: false,
		updateComplete : false
	}, // config
	app: {
		infoLoading: false,
		infoComplete: false,
		deleteLoading:false,
		deleteComplete:false
	},
	appsConfig: {
		getPending : false,
		getComplete: false,
		addLoading: false,
		addComplete : false
	},
	accountApps: {
		getLoading : false,
		getComplete: false,
		resetLoading: false,
		resetComplete : false
	},
	patientApps: {
		getLoading : false,
		getComplete: false,
		resetLoading: false,
		resetComplete : false
	}
};

const accountExternalAppsConfigSlice = createSlice({
	name: 'accountExternalAppsConfig',
	initialState: initialState,
  	reducers: {},
	// reducers: {
	// 	accountSliceClean(state, action) {
	// 	console.log('accountSliceClean', action);
	// 	state.config.pending = false;
	// 	state.config.complete = false;
	// 	state.config.error = '';
	// 	},
	// },

  extraReducers: (builder) => {
		//getExternalAppsConfigThunk
		builder.addCase(getExternalAppsConfigThunk.pending, (state) => {
			console.log('getExternalAppsConfigThunk.pending');
			state.config = {
				ExternalAppsEnabled: false
			};
			state.config.getPending = true;
			state.config.getComplete = false;

			state.config.updatePending = false;
			state.config.updateComplete = false;

			state.config.error = '';
		});

		builder.addCase(getExternalAppsConfigThunk.fulfilled, (state, action) => {
			state.config.getPending = false;
			state.config.getComplete = true;
			state.config = Object.assign(state.config, action.payload);
			});
			builder.addCase(getExternalAppsConfigThunk.rejected, (state, action) => {
			state.config.getPending = false;
			state.config.getComplete = false;

			// if (action.error.message && action.error.message.contains("404")){
			// 	// state.config = Object.assign(state.config, {
			// 	// 	Enabled : false,
			// 	// 	ReminderBeforeDays : 0,
			// 	// 	ReminderBeforeMinutes : 0
			// 	// });
			// 	//state.config.complete = true;
			// }

			state.config.error = action.error ? action.error.message! : '';
		});

		//enableExternalAppsThunk
		builder.addCase(enableExternalAppsThunk.pending, (state) => {
			state.config.updatePending = true;
			state.config.updateComplete = false;
			state.config.error = '';
		});
		builder.addCase(enableExternalAppsThunk.fulfilled, (state, action) => {
			state.config.updatePending = false;
			state.config.updateComplete = true;
			state.config = Object.assign(state.config, action.payload);
		});
		builder.addCase(enableExternalAppsThunk.rejected, (state, action) => {
			state.config.updatePending = false;
			state.config.updateComplete = false;
			state.config.error = action.error ? action.error.message! : '';
		});

		//getExternalAppsListThunk
		builder.addCase(getExternalAppsListThunk.pending, (state) => {
			state.appsConfig.getPending = true;
			state.appsConfig.getComplete = false;

			state.appsConfig.addLoading = false;
			state.appsConfig.addComplete = false;

			state.appsConfig.error = '';
		});
		builder.addCase(getExternalAppsListThunk.fulfilled, (state, action) => {
			state.appsConfig.getPending = false;
			state.appsConfig.getComplete = true;
			state.appsConfig = Object.assign(state.appsConfig, action.payload);
		});
		builder.addCase(getExternalAppsListThunk.rejected, (state, action) => {
			state.appsConfig.getPending = false;
			state.appsConfig.getComplete = false;
			state.appsConfig.error = action.error ? action.error.message! : '';
		});

		//addExternalAppThunk
		builder.addCase(addExternalAppThunk.pending, (state) => {
			state.appsConfig.addLoading = true;
			state.appsConfig.addComplete = false;
			state.appsConfig.error = '';
		});
		builder.addCase(addExternalAppThunk.fulfilled, (state, action) => {
			state.appsConfig.addLoading = false;
			state.appsConfig.addComplete = true;
			state.appsConfig = Object.assign(state.appsConfig, action.payload);
		});
		builder.addCase(addExternalAppThunk.rejected, (state, action) => {
			state.appsConfig.addLoading = false;
			state.appsConfig.addComplete = false;
			state.appsConfig.error = action.error ? action.error.message! : '';
		});

		//getAccountAppsAvailabilityThunk
		builder.addCase(getAccountAppsAvailabilityThunk.pending, (state) => {
			state.accountApps.getAvailabilityLoading = true;
			state.accountApps.getAvailabilityComplete = false;
			state.accountApps.error = '';
		});
		builder.addCase(getAccountAppsAvailabilityThunk.fulfilled, (state, action) => {
			state.accountApps.getAvailabilityLoading = false;
			state.accountApps.getAvailabilityComplete = true;
			state.accountApps = Object.assign(state.accountApps, action.payload);
		});
		builder.addCase(getAccountAppsAvailabilityThunk.rejected, (state, action) => {
			state.accountApps.getAvailabilityLoading = false;
			state.accountApps.getAvailabilityComplete = false;
			state.accountApps.error = action.error ? action.error.message! : '';
		});

		//updateAccountAppAvailabilityThunk
		builder.addCase(updateAccountAppAvailabilityThunk.pending, (state) => {
			console.log('updateAccountAppAvailabilityThunk.pending');
			state.accountApps.updateAvailabilityLoading = true;
			state.accountApps.updateAvailabilityComplete = false;
			state.accountApps.error = '';
		});
		builder.addCase(updateAccountAppAvailabilityThunk.fulfilled, (state, action) => {
			console.log('updateAccountAppAvailabilityThunk.fulfilled ', action);
			state.accountApps.updateAvailabilityLoading = false;
			state.accountApps.updateAvailabilityComplete = true;
			state.accountApps = Object.assign(state.accountApps, action.payload);
		});
		builder.addCase(updateAccountAppAvailabilityThunk.rejected, (state, action) => {
			console.log('updateAccountAppAvailabilityThunk.rejected action', action);
			console.log('updateAccountAppAvailabilityThunk.rejected action payload', action.payload);
			state.accountApps.updateAvailabilityLoading = false;
			state.accountApps.updateAvailabilityComplete = false;
			state.accountApps.error = action.error ? action.error.message! : '';
		});

		//updateAccountAppsAvailabilityThunk
		builder.addCase(updateAccountAppsAvailabilityThunk.pending, (state) => {
			console.log('updateAccountAppsAvailabilityThunk.pending');
			state.accountApps.updateAvailabilityLoading = true;
			state.accountApps.updateAvailabilityComplete = false;
			state.accountApps.error = '';
		});
		builder.addCase(updateAccountAppsAvailabilityThunk.fulfilled, (state, action) => {
			console.log('updateAccountAppsAvailabilityThunk.fulfilled ', action);
			state.accountApps.updateAvailabilityLoading = false;
			state.accountApps.updateAvailabilityComplete = true;
			state.accountApps = Object.assign(state.accountApps, action.payload);
		});
		builder.addCase(updateAccountAppsAvailabilityThunk.rejected, (state, action) => {
			console.log('updateAccountAppsAvailabilityThunk.rejected action', action);
			console.log('updateAccountAppsAvailabilityThunk.rejected action payload', action.payload);
			state.accountApps.updateAvailabilityLoading = false;
			state.accountApps.updateAvailabilityComplete = false;
			state.accountApps.error = action.error ? action.error.message! : '';
		});

		//getAccountAppsThunk
		builder.addCase(getAccountAppsThunk.pending, (state) => {
			state.accountApps.getLoading = true;
			state.accountApps.getComplete = false;
			state.accountApps.error = '';
		});
		builder.addCase(getAccountAppsThunk.fulfilled, (state, action) => {
			state.accountApps.getLoading = false;
			state.accountApps.getComplete = true;
			state.accountApps = Object.assign(state.accountApps, action.payload);
		});
		builder.addCase(getAccountAppsThunk.rejected, (state, action) => {
			state.accountApps.getLoading = false;
			state.accountApps.getComplete = false;
			state.accountApps.error = action.error ? action.error.message! : '';
		});

		//updateAccountAppsConfigThunk
		builder.addCase(updateAccountAppsConfigThunk.pending, (state) => {
			console.log('updateAccountAppsConfigThunk.pending');
			state.accountApps.resetLoading = true;
			state.accountApps.resetComplete = false;
			state.accountApps.error = '';
		});
		builder.addCase(updateAccountAppsConfigThunk.fulfilled, (state, action) => {
			console.log('updateAccountAppsConfigThunk.fulfilled ', action);
			state.accountApps.resetLoading = false;
			state.accountApps.resetComplete = true;
			state.accountApps = Object.assign(state.accountApps, action.payload);
		});
		builder.addCase(updateAccountAppsConfigThunk.rejected, (state, action) => {
			console.log('updateAccountAppsConfigThunk.rejected action', action);
			console.log('updateAccountAppsConfigThunk.rejected action payload', action.payload);
			state.accountApps.resetLoading = false;
			state.accountApps.resetComplete = false;
			state.accountApps.error = action.error ? action.error.message! : '';
		});

		//resetAccountAppThunk
		builder.addCase(resetAccountAppThunk.pending, (state) => {
			console.log('resetAccountAppThunk.pending');
			state.accountApps.resetLoading = true;
			state.accountApps.resetComplete = false;
			state.accountApps.error = '';
		});
		builder.addCase(resetAccountAppThunk.fulfilled, (state, action) => {
			console.log('resetAccountAppThunk.fulfilled ', action);
			state.accountApps.resetLoading = false;
			state.accountApps.resetComplete = true;
			state.accountApps = Object.assign(state.accountApps, action.payload);
		});
		builder.addCase(resetAccountAppThunk.rejected, (state, action) => {
			console.log('resetAccountAppThunk.rejected action', action);
			console.log('resetAccountAppThunk.rejected action payload', action.payload);
			state.accountApps.resetLoading = false;
			state.accountApps.resetComplete = false;
			state.accountApps.error = action.error ? action.error.message! : '';
		});

		//getPatientAppsThunk
		builder.addCase(getPatientAppsThunk.pending, (state) => {
			state.patientApps.getLoading = true;
			state.patientApps.getComplete = false;
			state.patientApps.error = '';
		});
		builder.addCase(getPatientAppsThunk.fulfilled, (state, action) => {
			state.patientApps.getLoading = false;
			state.patientApps.getComplete = true;
			state.patientApps = Object.assign(state.patientApps, action.payload);
		});
		builder.addCase(getPatientAppsThunk.rejected, (state, action) => {
			state.patientApps.getLoading = false;
			state.patientApps.getComplete = false;
			state.patientApps.error = action.error ? action.error.message! : '';
		});

		//updatePatientAppsConfigThunk
		builder.addCase(updatePatientAppsConfigThunk.pending, (state) => {
			console.log('updatePatientAppsConfigThunk.pending');
			state.patientApps.resetLoading = true;
			state.patientApps.resetComplete = false;
			state.patientApps.error = '';
		});
		builder.addCase(updatePatientAppsConfigThunk.fulfilled, (state, action) => {
			console.log('updatePatientAppsConfigThunk.fulfilled ', action);
			state.patientApps.resetLoading = false;
			state.patientApps.resetComplete = true;
			state.patientApps = Object.assign(state.patientApps, action.payload);
		});
		builder.addCase(updatePatientAppsConfigThunk.rejected, (state, action) => {
			console.log('updatePatientAppsConfigThunk.rejected action', action);
			console.log('updatePatientAppsConfigThunk.rejected action payload', action.payload);
			state.patientApps.resetLoading = false;
			state.patientApps.resetComplete = false;
			state.patientApps.error = action.error ? action.error.message! : '';
		});

		//resetPatientAppThunk
		builder.addCase(resetPatientAppThunk.pending, (state) => {
			console.log('resetPatientAppThunk.pending');
			state.patientApps.resetLoading = true;
			state.patientApps.resetComplete = false;
			state.patientApps.error = '';
		});
		builder.addCase(resetPatientAppThunk.fulfilled, (state, action) => {
			console.log('resetPatientAppThunk.fulfilled ', action);
			state.patientApps.resetLoading = false;
			state.patientApps.resetComplete = true;
			state.patientApps = Object.assign(state.patientApps, action.payload);
		});
		builder.addCase(resetPatientAppThunk.rejected, (state, action) => {
			console.log('resetPatientAppThunk.rejected action', action);
			console.log('resetPatientAppThunk.rejected action payload', action.payload);
			state.patientApps.resetLoading = false;
			state.patientApps.resetComplete = false;
			state.patientApps.error = action.error ? action.error.message! : '';
		});

		//getAppInfoThunk
		builder.addCase(getAppInfoThunk.pending, (state) => {
			state.app.infoLoading = true;
			state.app.infoComplete = false;
			state.app.error = '';
		});
		builder.addCase(getAppInfoThunk.fulfilled, (state, action) => {
			state.app.infoLoading = false;
			state.app.infoComplete = true;
			state.app = Object.assign(state.app, action.payload);
		});
		builder.addCase(getAppInfoThunk.rejected, (state, action) => {
			state.app.infoLoading = false;
			state.app.infoComplete = false;
			state.app.error = action.error ? action.error.message! : '';
		});

		//deleteExternalAppThunk
		builder.addCase(deleteExternalAppThunk.pending, (state) => {
			state.app.deleteLoading = true;
			state.app.deleteComplete = false;
			state.app.error = '';
		});
		builder.addCase(deleteExternalAppThunk.fulfilled, (state, action) => {
			state.app.deleteLoading = false;
			state.app.deleteComplete = true;
			state.app = Object.assign(state.app, action.payload);
		});
		builder.addCase(deleteExternalAppThunk.rejected, (state, action) => {
			state.app.deleteLoading = false;
			state.app.deleteComplete = false;
			state.app.error = action.error ? action.error.message! : '';
		});
  },
});

//export const { accountSliceClean } = accountExternalAppsConfigSlice.actions;
export default accountExternalAppsConfigSlice;
